import angular from "angular";
import InstructorReportCardsController from "./instructor-upcoming-students-report-cards.controller";
import template from "./instructor-upcoming-students-report-cards.html";
import { toYMD } from "../../../common/helpers/time";

getInstructorsUpcomingStudents.$inject = ["UserService", "UsersModel"];
function getInstructorsUpcomingStudents(UserService, UsersModel) {
  const instructor = UserService.getCurrentUser();
  const today = toYMD(new Date());
  const initialFilterData = {
    id: instructor.id,
    from: today,
    to: today,
  };
  return UsersModel.getInstructorsUpcomingStudents(initialFilterData).then(
    (response) => {
      return response.students.filter((student) => {
        student.name = student.firstname + " " + student.lastname;
        return student;
      });
    },
  );
}

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.instructor.dashboard.reportcards", {
    url: "/reportcards",
    template: template,
    controller: InstructorReportCardsController,
    controllerAs: "vm",
    resolve: {
      students: getInstructorsUpcomingStudents,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.parent,
        USER_ROLES.owner,
        USER_ROLES.instructor,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("instructor.dashboard.reportcards", [])
  .config(config)
  .controller(
    "InstructorReportCardsController",
    InstructorReportCardsController,
  );
